module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/wedding_guests-36eabcd0b15a9efcbb79d49e14152439.svg";